jQuery(document).ready(function($) {

    //matchHeight
    $('.eqheight').matchHeight();

    //slickSliders
    $('.videos-slider').slick({
      autoplay: false,
      arrows: true,
      dots: false,
      slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    }); 

    //magnificPopup
  $('.popup-video').magnificPopup({
    type:'iframe'
  });

});